import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Hero1 from "../assets/img/365hero1.png";
import Hero2 from "../assets/img/365hero2.png";
import Hero3 from "../assets/img/365hero3.png";

const HeroSlider = ({ slides }) => {
  return (
    <div className="relative w-full h-full overflow-hidden">
      <Carousel
        showStatus={false}
        autoPlay={true}
        infiniteLoop={true}
        swipeable={true}
      >
        <div>
          <div className="relative w-full h-[300px]  md:h-full overflow-hidden group sm:rounded-3xl">
            <img
              src={Hero1}
              alt="Background"
              className="w-full h-full object-cover md:rounded-3xl transition-transform duration-500 group-hover:scale-110"
            />

            <div className="absolute inset-0 flex items-start text-start justify-center text-white p-10  flex-col gap-8">
              <h1 className="capitalize text-3xl md:text-6xl md:w-1/2 font-bold">
                study abroad <span className="text-secondary">made</span> easy
              </h1>
              <p className="md:w-80">
                Let’s guide you through every step of the application process to
                any university of your choice
              </p>
              <div>
                <a
                  href="/application"
                  className="uppercase bg-secondary py-3 px-6 rounded-full hover:bg-gray-cool duration-300"
                >
                  get started
                </a>
              </div>
            </div>
          </div>
        </div>
        <div>
        <div className="relative w-full h-[300px] md:h-full overflow-hidden group sm:rounded-3xl">
            <img
              src={Hero2}
              alt="Background"
              className="w-full h-full object-cover sm:rounded-3xl transition-transform duration-500 group-hover:scale-110"
            />

            <div className="absolute inset-0 flex items-center text-center justify-start text-white p-8  flex-col gap-6">
              <h1 className="capitalize text-3xl md:text-6xl md:w-3/5 font-bold">
                study abroad made easy
              </h1>
              <p className="md:w-96">
                Let’s guide you through every step of the application process to
                any university of your choice
              </p>
              <div>
                <a
                  href="/application"
                  className="uppercase bg-secondary py-3 px-6 rounded-full hover:bg-gray-cool duration-300"
                >
                  get started
                </a>
              </div>
            </div>
            
          </div>
        </div>
        <div>
        <div className="relative w-full h-[300px] md:h-full overflow-hidden group sm:rounded-3xl">
            <img
              src={Hero3}
              alt="Background"
              className="w-full h-full object-cover sm:rounded-3xl transition-transform duration-500 group-hover:scale-110"
            />

            <div className="absolute inset-0 flex items-center text-center justify-center text-white p-10  flex-col gap-4 md:gap-8">
              <h1 className="capitalize text-2xl md:text-6xl md:w-3/4 font-bold">
              Premium education from leading institutions
              </h1>
              <p className="md:w-96">
                Let’s guide you through every step of the application process to
                any university of your choice
              </p>
              <div>
                <a
                  href="/application"
                  className="uppercase bg-secondary py-3 px-6 rounded-full hover:bg-gray-cool duration-300"
                >
                  get started
                </a>
              </div>
            </div>
          </div>
        </div>
      </Carousel>
    </div>
  );
};

export default HeroSlider;
